import { manualUpdateActionType } from "../actions/actionTypes";

const initialState = {
  isTableLoading: false, 
  data: null,
  error: null,
};

const getDTMetricReducer = (state = initialState, action) => {
  switch (action.type) {
    case manualUpdateActionType.GET_DT_VALUE:
      return {
        ...state,
        isTableLoading: true,
        error: null,
      };
    case manualUpdateActionType.SET_DT_VALUE_SUCCESSED:
      return {
        ...state,
        isTableLoading: false, 
        data: action.payload.data,
        stateUpdated: true,
      };

    case manualUpdateActionType.SET_DT_DROPDOWN_VALUE_FAILED:
      return {
        ...state,
        isTableLoading: false,
        error: action.payload.msg,
        stateUpdated: false,
      };

    default:
      return state;
  }
};

export default getDTMetricReducer;